import debounce from 'lodash/debounce';
import React, { useRef } from 'react';
import useMissionsProgress from 'shared/api/MissionsInterface/hooks/useMissionsProgress';
import useFeatureFlags from 'shared/hooks/useFeatureFlags';
import useMissionsTooltips from 'shared/hooks/useMissionsTooltips';
import { FE_MISSIONS } from 'shared/utils/featureFlags/constants';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { missionFinished, getBattlesInProgressTooltipDetail } from 'shared/utils/missionProgress/tooltipsDetail';
import { useTheme } from 'styled-components';
import Bar from '../Bar/Bar';
import {
  CollectBarContainerStyle,
  Container,
  CollectBarFillStyle,
  RankContainer,
  ProgressBarRankText,
} from './styledComponent';
import BarTimerContainer from './components/BarTimerContainer';

const MissionsProgress = props => {
  const { MissionsProgress } = useTheme();
  const mouseOver = useRef(false);
  const missionFinishedTooltipDetail = missionFinished();
  const battlesInProgressTooltipDetail = getBattlesInProgressTooltipDetail(MISSIONS_PROGRESS_CONTAINER);

  const {
    currentMission: { endTimestamp, missionRank = 0 },
    missionsAssets,
    battlesAssets,
    isMissionsScreen,
    showLinkLoyaltyCardSetting,
  } = props;

  const { getFeatureConfig } = useFeatureFlags();
  const { skinning } = getFeatureConfig(FE_MISSIONS);

  const { clientProgress, serverProgress, isCollectStatus, battlesRunning } = useMissionsProgress(props);

  const { onProgressPressHandler } = useMissionsTooltips({
    ...props,
    missionFinishedTooltipDetail,
    battlesInProgressTooltipDetail,
    battlesRunning,
    isCollectStatus,
  });

  const onMouseEnterHandler = () => {
    if (serverProgress < 100 && !isCollectStatus && !mouseOver.current) {
      mouseOver.current = true;
      onProgressPressHandler();
      setTimeout(() => (mouseOver.current = false), 4500);
    }
  };

  return (
    <Container
      id={MISSIONS_PROGRESS_CONTAINER}
      onClick={
        serverProgress < 100 && !isCollectStatus
          ? null
          : debounce(
              () => {
                onProgressPressHandler();
              },
              1500,
              { leading: true, trailing: false }
            )
      }
      onMouseEnter={onMouseEnterHandler}
      withCard={showLinkLoyaltyCardSetting}
    >
      <Bar
        key={isMissionsScreen ? 'missions-screen' : 'normal-screen'}
        barContainerStyle={{
          ...(!isCollectStatus
            ? {
                ...(skinning && {
                  background: `linear-gradient(180deg, ${skinning.barBackgroundColors[0]} 0%, ${skinning.barBackgroundColors[1]} 100%)`,
                }),
              }
            : CollectBarContainerStyle),
        }}
        progressStyle={{
          ...MissionsProgress.ProgressBarFill,
          ...(isCollectStatus && CollectBarFillStyle),
          ...(skinning && {
            background: `linear-gradient(180deg, ${skinning.progressBarColors[0]} 0%, ${skinning.progressBarColors[1]} 100%)`,
          }),
        }}
        barIcon={battlesRunning ? battlesAssets?.BATTLES_ICON : missionsAssets.TOP_BAR_ICON}
        iconStyle={showLinkLoyaltyCardSetting ? MissionsProgress.MissionIcon : MissionsProgress.MissionIconWithoutCard}
        progress={!isCollectStatus ? Math.floor(clientProgress) : 95}
        percentageStyle={{
          ...(showLinkLoyaltyCardSetting ? MissionsProgress.TextProgress : MissionsProgress.TextProgressWithoutCard),
          ...MissionsProgress.TextProgress,
          left: `calc(50% - ${serverProgress < 100 ? 1 : 1.5}rem)`,
        }}
        label={isCollectStatus && getText(TEXT_KEY.COLLECT_BUTTON)}
        labelStyle={MissionsProgress.BarLabel}
        shineEffect={!isCollectStatus}
        shineEffectStyles={MissionsProgress.BarShineEffect}
        showPercentage={!isCollectStatus}
        showProgress={true}
      />
      {battlesRunning && (
        <RankContainer isLoyaltyCardLinkVisible={showLinkLoyaltyCardSetting}>
          <ProgressBarRankText data-text={missionRank} size={'1.5vw'}>
            <span>{missionRank}</span>
          </ProgressBarRankText>
        </RankContainer>
      )}
      <BarTimerContainer missionsAssets={missionsAssets} endTimestamp={endTimestamp} />
    </Container>
  );
};

export default MissionsProgress;

const MISSIONS_PROGRESS_CONTAINER = 'missions-progress-container';

